var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 7.99984C9.10461 7.99984 10 7.10441 10 5.99984C10 4.89527 9.10461 3.99984 8.00004 3.99984C6.89547 3.99984 6.00004 4.89527 6.00004 5.99984C6.00004 7.10441 6.89547 7.99984 8.00004 7.99984Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9134 5.6675C14.383 2.68817 11.414 0.666504 8.00004 0.666504C4.5787 0.666504 1.60404 2.69684 0.0767031 5.68684C-0.0229635 5.88217 -0.0229635 6.1175 0.0767031 6.31284C1.60404 9.30284 4.5787 11.3332 8.00004 11.3332C11.414 11.3332 14.383 9.3115 15.9134 6.33217C16.02 6.12484 16.02 5.87484 15.9134 5.6675ZM8.00004 9.99984C5.30304 9.99984 2.8107 8.4755 1.42137 5.99984C2.8107 3.52384 5.30304 1.99984 8.00004 1.99984C10.6957 1.99984 13.1894 3.5245 14.5787 5.99984C13.1894 8.47517 10.6957 9.99984 8.00004 9.99984Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show_password.512b23fe70e22520a52762bc3e7dd6fe.svg";
export { ForwardRef as ReactComponent };